const QUERIES = {
  USERS_LIST: 'users-list',
  ADMINS_LIST: 'admins-list'
}

export { QUERIES }
